var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { Colors } from '../ThemeProvider/type';
import { useSpinner } from './useSpinner';
/**
 * # Spinner
 *
 * @description [vercel design spinner](https://vercel.com/design/spinner)
 *
 * 기본적인 스피너 컴포넌트입니다. 해당 컴포넌트로 모든 로딩 상태를 나타냅니다.
 *
 * @param {SpinnerProps} {@link SpinnerProps} 기본적인 Spinner 요소
 *
 * @example ```tsx
 * <Spinner size={30} />
 * ```
 */
export var Spinner = function (props) {
    var size = useSpinner(props).size;
    return (<SpinnerWrapper size={size}>
      {__spreadArray([], Array(12), true).map(function (_, index) {
            return <SpinnerStick key={"spinner-stick-".concat(index)} index={index}/>;
        })}
    </SpinnerWrapper>);
};
var SpinnerStickAnimation = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0.15;\n  }\n"], ["\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0.15;\n  }\n"])));
var SpinnerWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ", "\n"], ["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ", "\n"])), function (props) { return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: ", ";\n    height: ", ";\n  "], ["\n    width: ", ";\n    height: ", ";\n  "])), "".concat(props.size, "px"), "".concat(props.size, "px")); });
var SpinnerStick = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  animation: ", " 1.2s linear infinite;\n  position: absolute;\n  width: 24%;\n  height: 8%;\n  border-radius: 5px;\n  background: ", ";\n  ", "\n"], ["\n  animation: ", " 1.2s linear infinite;\n  position: absolute;\n  width: 24%;\n  height: 8%;\n  border-radius: 5px;\n  background: ", ";\n  ", "\n"])), SpinnerStickAnimation, Colors.PRIMARY.ACCENT_7, function (props) { return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    animation-delay: ", "s;\n    transform: rotate(", "deg) translate(146%);\n  "], ["\n    animation-delay: ", "s;\n    transform: rotate(", "deg) translate(146%);\n  "])), -1.2 + props.index * 0.1, 30 * props.index); });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Spinner.jsx.map